// @ts-nocheck
import Accordion from "@insite/mobius/Accordion";
import Button from "@insite/mobius/Button";
import GridItem from "@insite/mobius/GridItem";
import Icon from "@insite/mobius/Icon";
import Popover from "@insite/mobius/Popover";
import Typography from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import Colors from "@store/Themes/common/styleguide/config/colors";
import styled from "styled-components";

interface PopoverTriggerProps {
    isError: boolean;
}
const GridItemLocationPicker = styled(GridItem)`
    && {
        display: block;
        max-width: 400px !important;
    }
`;
// getColors doesn't seem to work inside of the nested function context
const LocationsListDropdown = styled(Button)<PopoverTriggerProps>`
    && {
        display: block;
        width: 100%;
        padding: 0 10px;
        background-color: white;
        color: ${getColor("text.main")};
        font-weight: 400;
        border: ${p => (p.isError ? `2px solid ${Colors?.danger?.main}` : `1px solid${Colors?.common?.borderDark}`)};
        min-height: 42px !important;
        text-align: left;
        font-size: 1rem;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
`;

const LocationsListDropdownIcon = styled(Icon)`
    && {
        margin-left: auto;
    }
`;

const Badge = styled(Typography)`
    && {
        display: flex;
        padding: 3px 9px 3px 8px;
        margin-left: 0.75rem;
        margin-right: 0.75rem;
        letter-spacing: -0.025em;
        background-color: ${getColor("checkboxPickerBackground")};
        border-radius: 41%;
        color: ${getColor("secondary.main")};
        font-weight: 900;
        text-align: center;
        font-size: 0.75rem;
        align-items: center;
        justify-content: center;
    }
`;

const LocationPickerDropdown = styled.div`
    display: block;
`;

const LabelLocationPicker = styled(Typography)`
    && {
        font-size: 1rem;
        text-transform: none;
        color: ${getColor("common.accentContrast")};
        min-height: 1.375rem;
        display: inline-block;
        width: 100%;
        font-weight: 700;
        line-height: 1.375;
        padding-bottom: 4px;
    }
`;
const StyledSpan = styled.span`
    font-weight: 700;
    font-style: italic;
    margin-left: 0.5em;
    font-size: 0.8125rem;
`;

const PopoverLocationPicker = styled(Popover)`
    && {
        overflow-y: auto !important;
        max-height: 400px;
    }
`;

const LocationPickerWrapper = styled.div`
    padding: 0.5rem 1.25rem 1.25rem 1.25rem;
`;

const LocationPickerHeader = styled.div`
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    margin-top: 1rem;
    margin-bottom: 1rem;
`;

const SelectAllButton = styled(Button)`
    && {
        min-width: auto;
        min-height: auto;
        background-color: transparent !important;
        border: none !important;
        color: ${getColor("text.main")};
        padding: 0;
        font-weight: 400;
        & span {
            font-size: 0.9rem !important;
        }
    }
`;

const SearchLocationPicker = styled.div`
    padding-bottom: 0.5rem;
    & span {
        width: 36px;
        height: 36px;
    }
`;

const AccordionLocationPicker = styled(Accordion)`
    && {
        display: block;
        dd[role="region"] {
            margin-top: 0.5rem;
            margin-left: -1.25rem;
            margin-right: -1.25rem;
            margin-bottom: 0.125rem;
            background-color: ${getColor("common.backgroundContrastLight")};
            padding: 0.75rem 2rem;
        }
        button {
            display: flex;
            align-items: center;
            margin-top: 0.75rem;
            margin-bottom: 0;
            line-height: 1.5;
            padding: 0.125rem 0;
            background-color: ${getColor("primary.contrast")};
            > div[data-id="checkbox"] {
                display: flex;
                align-items: center;
            }
            &::after {
                display: none;
            }
            &:focus {
                outline-color: transparent !important;
                outline: 0;
            }
        }
        .toggle {
            width: 18px;
            min-width: 18px;
            height: 18px;
        }
        .toggle svg {
            width: 15px;
            min-width: 15px;
            height: 15px;
        }
    }
`;

export default {
    GridItemLocationPicker,
    LocationsListDropdown,
    LocationsListDropdownIcon,
    Badge,
    LocationPickerDropdown,
    LabelLocationPicker,
    StyledSpan,
    PopoverLocationPicker,
    LocationPickerWrapper,
    LocationPickerHeader,
    SelectAllButton,
    SearchLocationPicker,
    AccordionLocationPicker,
};
